import React, { memo } from 'react'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import IconButton from '@material-ui/core/IconButton'
import { Tooltip } from '@material-ui/core'

import WhiteBlockWraper from 'components/CommonUI/WhiteBlockWraper/WhiteBlockWraper'
import { devicesIconComponent } from 'constants/deviceTypeConstants'

import { hex } from 'utils/hex'

const DeviceItem = ({
  id,
  color = '#E0CA05',
  icon = 'lightning',
  name = 'Refrigerator',
  //connected = 0,
  handleEditOpen,
}) => {
  const IconCompomemnt =
    devicesIconComponent[icon]?.ComponentIcon || (() => null)

  const handleClickEdit = () => {
    handleEditOpen({ name, color, icon, id })
  }

  return (
    <div className="device_manager_body_item_wrap">
      <WhiteBlockWraper className="device_item_container">
        <div
          className="device_color_icon"
          style={{ backgroundColor: hex(color) }}
        >
          <IconCompomemnt className="device_item_icon" color={color} />
        </div>
        <div className="device_item_info_container">
          <Tooltip placement="top" title={<span style={{ fontSize: '13px' }}>{name}</span>}>
            <span className="device_item_info_name">{name}</span>
          </Tooltip>
          {/* <span className="device_item_info_connected_count">
            {connected} devices connected
          </span> */}
        </div>
        <IconButton
          className="device_item_info_edit_button"
          onClick={handleClickEdit}
        >
          <EditOutlinedIcon className="device_item_info_edit_icon" />
        </IconButton>
      </WhiteBlockWraper>
    </div>
  )
}

export default memo(DeviceItem)
